var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRainSoil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rain-soil"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.632324 32.2268C1.25903 30.3939 3.2375 29.3161 4.5651 29.5307C6.36752 26.4541 9.3294 24.9673 13.8099 26.2095C17.3613 24.1209 22.6099 24.5436 24.9385 27.952C27.3213 27.0463 30.3446 27.8326 31.969 30.674C33.0988 30.1895 35.4623 30.8524 35.517 32.2268H0.632324Z",
    fill: "#10823C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2295 15.0219C26.2433 12.8694 24.7857 11.0358 23.7707 8.67318C22.7844 11.1541 21.3047 12.8356 20.3039 15.041C17.3636 21.5193 30.2011 21.5048 27.2295 15.0219Z",
    fill: "#1AB756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4436 8.51096C17.1425 6.97043 18.176 5.79582 18.865 4.06299C19.5743 5.71328 20.5921 6.99391 21.2812 8.49735C23.3567 13.0259 14.3896 13.0362 16.4436 8.51096Z",
    fill: "#1AB756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02911 15.9526C10.2977 13.1572 12.1732 11.0257 13.4235 7.88096C14.7101 10.876 16.5573 13.2 17.8078 15.9285C21.5742 24.1455 5.30224 24.1644 9.02911 15.9526Z",
    fill: "#1AB756"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainSoil);
export default __webpack_public_path__ + "static/media/rain-soil.c81352724a14d0fb9dfacdcd3dbbbc8e.svg";
export { ForwardRef as ReactComponent };